import axios from "axios";
import { useQuery } from "react-query";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

export const useMapCustomerSamples = (
  periodStart,
  periodEnd,
  locations,
  selectedCustomer
) => {
  const locationIds = locations
    ? locations.map((location) => location.locationId)
    : [];
  return useQuery(
    [
      "map-customer-samples",
      periodStart,
      periodEnd,
      locationIds,
      selectedCustomer,
    ],
    async () => {
      const { data } = await axios.get("/map-samples/map-customer-samples", {
        params: { periodStart, periodEnd, locationIds, selectedCustomer },
      });
      if (!data) {
        throw new Error("No data found for the specified period.");
      }
      return data;
    },
    {
      retry: false,
      enabled: !!periodStart && !!periodEnd,
    }
  );
};
